import { Contractors } from 'src/components/contractor-list/contractors/Contractors'
import React from 'react'

export const ContractorsPage = () => {
  return <Contractors />
}
